import { observable, action, reaction } from 'mobx';

export default class CommontStore {
    rootStore;
    
    constructor(rootStore){
        this.rootStore = rootStore;

        reaction(() => this.token, token => {
            if(token){
                window.localStorage.setItem('crifJwt', token);
            }else{
                window.localStorage.removeItem('crifJwt');
            }
        })
    }

    @observable token = window.localStorage.getItem('crifJwt');
    
    @observable appLoaded = false;

    @action setToken = (token) => {
        this.token = token;
    }

    @action setAppLoaded = () => {
        this.appLoaded = true;
    }
     
}